import { getBillItemGroupTypeName } from '@/enums/billItemGroupTypes';
import { GradeYears } from '@/enums/gradeYears';
import { BillData, BillItemGroup, BillItemData } from '@/models/billData';

export function refrectDetails(billItems: BillItemGroup[], billData: BillData) {
  billData.items.forEach((item) => {
    refrectDetail(billItems, billData.billGradeYear, item);
  });
}

export function refrectDetail(billItems: BillItemGroup[], billGradeYear: GradeYears, row: BillItemData) {
  const group = billItems.find((item) => item.groupType === row.groupType);
  if (!group) {
    return;
  }
  row.groupName = getBillItemGroupTypeName(group.groupType);
  const billItem = group.billItems.find((item) => item.itemId === row.itemId);
  if (billItem) {
    row.itemName = billItem.itemName;
    row.nonTaxable = billItem.nonTaxable;
    let gradeYearItem = billItem.gradeYearItems.find((item) => item.gradeYear === billGradeYear);
    if (!gradeYearItem) {
      gradeYearItem = billItem.gradeYearItems.find((item) => item.gradeYear === GradeYears.All);
    }
    if (gradeYearItem) {
      row.unitPrice = gradeYearItem.unitPrice;
    } else {
      row.unitPrice = 0;
    }
  }
}
